import _ from 'lodash';
import { APP_SETTINGS_VERSION_LATEST } from '@wix/wix-vod-constants/app-settings';

export const isLatestVersion = (appSettings) =>
  _.get(appSettings, 'numbers.settingsVersion') === APP_SETTINGS_VERSION_LATEST;
